module.exports = __webpack_public_path__ + "assets/img/pic-m1.46f4e48e.jpg";